module.exports = __webpack_public_path__ + "img/empty_blue.ce204839.png";